import React from 'react';
import { FlexRow, SvgIcon } from '@make-software/cspr-design';
import { PaginationInfoText } from './pagination-info-text';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button } from '@block-explorer/ui';
import { useDispatch, useSelector } from 'react-redux';
import { NFT_TABLE_VIEW_IDS, setTableViewType } from '../../redux/table-view';
import type { NftTableViewId, TableViewId } from '../../redux/table-view';
import { RootState } from 'typesafe-actions';
import { TableViewType } from './table-settings';

const ButtonsContainer = styled(FlexRow)(({ theme }) => ({
  backgroundColor: theme.styleguideColors.fillSecondary,
  borderRadius: '4px',
}));

const StyledSvgIcon = styled(SvgIcon)<{ isActive?: boolean }>(
  ({ theme, isActive }) => ({
    path: {
      fill: isActive
        ? theme.styleguideColors.contentRed
        : theme.styleguideColors.contentTertiary,
    },
  })
);

const StyledButton = styled(Button)(({ theme }) =>
  theme.withMedia({
    width: '28px',
    minHeight: 24,
    ':hover, :active': {
      [StyledSvgIcon]: {
        path: {
          fill: theme.styleguideColors.contentRed,
        },
      },
    },
  })
);

const TableButton = styled(StyledButton)(({ theme }) =>
  theme.withMedia({
    padding: '4px 4px 4px 8px',
    borderRadius: '4px 0px 0px 4px',
  })
);
const FeedButton = styled(StyledButton)(({ theme }) =>
  theme.withMedia({
    padding: '4px 8px 4px 4px',
    borderRadius: '0px 4px 4px 0px ',
  })
);

const isNftTableViewId = (tableId: TableViewId): tableId is NftTableViewId =>
  NFT_TABLE_VIEW_IDS.includes(tableId as NftTableViewId);

export const TableToFeedSwitch = ({ tableId }: { tableId: TableViewId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const viewType = useSelector((state: RootState) => state.tablesView[tableId]);

  const isNftTable = isNftTableViewId(tableId);

  const handleChangeViewType = (viewType: TableViewType) => {
    dispatch(setTableViewType({ tableId, viewType }));
  };
  return (
    <FlexRow itemsSpacing={4} align={'center'}>
      <PaginationInfoText>
        <Trans t={t}>Page view</Trans>
      </PaginationInfoText>
      <ButtonsContainer>
        <TableButton
          onClick={() => handleChangeViewType(TableViewType.table)}
          color={'secondaryRed'}
        >
          <StyledSvgIcon
            src={
              isNftTable
                ? 'assets/icons/ic-nft-table.svg'
                : 'assets/icons/ic-table.svg'
            }
            isActive={viewType === TableViewType.table}
          />
        </TableButton>
        <FeedButton
          onClick={() => handleChangeViewType(TableViewType.secondary)}
          color={'secondaryRed'}
        >
          <StyledSvgIcon
            src={
              isNftTable
                ? 'assets/icons/ic-table.svg'
                : 'assets/icons/ic-feed.svg'
            }
            isActive={viewType === TableViewType.secondary}
          />
        </FeedButton>
      </ButtonsContainer>
    </FlexRow>
  );
};
